module.exports = __webpack_public_path__ + "img/bar_graph_multi.ea3f6c50.jpg";